"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createServerSessionManager = void 0;
const lodash_1 = __importDefault(require("lodash"));
const createServerSessionManager = (config) => {
    {
        const _appsInstances = {
            ...config.appsInstances,
        };
        const getVisitorId = () => undefined;
        const getAppInstanceByAppDefId = (appDefId) => {
            const { instance } = _appsInstances[appDefId] || {};
            return instance;
        };
        return {
            getAllInstances() {
                return _appsInstances;
            },
            getAppInstanceByAppDefId,
            getSmToken() {
                return config.smToken;
            },
            getSiteMemberId() {
                return undefined;
            },
            getVisitorId,
            loadNewSession: async () => { },
            addLoadNewSessionCallback: () => lodash_1.default.noop,
            getHubSecurityToken() {
                return 'NO_HS';
            },
            getUserSession() {
                return config.svSession;
            },
            getCtToken() {
                return undefined;
            },
            setUserSession: lodash_1.default.noop,
            getContactId() {
                return undefined;
            },
        };
    }
};
exports.createServerSessionManager = createServerSessionManager;
//# sourceMappingURL=serverSessionManager.js.map